import React from 'react';
import PropTypes from 'prop-types';
import style from '../styles/headerDetailsTable.scss';
import { EllipsisBlock } from '../../../../../cm/common/styled';
import { getCategoryLabel } from '../../../../../common/utils';

function ConfigDetails({ entries = [] }) {
  return (
    <div className={style.configContainer}>
      {entries.map((entry) => {
        return (
          <div key={entry?.category} className={style.configContent}>
            <div className={style.headers}>
              <EllipsisBlock title={entry?.category}>
                {getCategoryLabel(entry?.category)}
              </EllipsisBlock>
            </div>
            <div>
              <EllipsisBlock title={entry?.value}>{entry?.value}</EllipsisBlock>
            </div>
          </div>
        );
      })}
    </div>
  );
}

ConfigDetails.propTypes = {
  entries: PropTypes.array
};

export default ConfigDetails;
